/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1758
 */

"use strict"

var r = require(/* 257 */"./1754/257/index")
var /* [auto-meaningful-name] */require_401_$_1754_401$findIndex = require(/* 401 */"./1754/401").findIndex
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("findIndex", function (e) {
  return require_401_$_1754_401$findIndex(r$aTypedArray(this), e, arguments.length > 1 ? arguments[1] : undefined)
})
